<template>
  <div>
    <div class="cnt-terms">
      <nav class="nv-terms">
        <router-link to="/">
          <img
            class="lg-terms"
            width="120"
            src="//static.slothtech.io/slothtech/logo-slothtech-verde.png"
            alt
          />
        </router-link>
        <p>Términos y condiciones</p>
      </nav>
      <div class="terms">
        <div class="terms-sidebar">
          <ul class="list-terms">
            <li class="item-terms active">
              <a href="#privacy">Privacy Policy of Slothtech</a>
            </li>
            <li class="item-terms">
              <a href="#information-collection">Information Collection and Use</a>
            </li>
            <li class="item-terms">
              <a href="#log-data">Log Data</a>
            </li>
            <li class="item-terms">
              <a href="#services-providers">Service Providers</a>
            </li>
            <li class="item-terms">
              <a href="#security">Security</a>
            </li>
            <li class="item-terms">
              <a href="#links">Links to Other Sites</a>
            </li>
            <li class="item-terms">
              <a href="#changes">Changes to This Privacy Policy</a>
            </li>
            <li class="item-terms">
              <a href="#contact">Contact Us</a>
            </li>
          </ul>
        </div>
        <div class="terms-content">
          <div id="privacy" name="privacy-policy">
            <h1>Privacy Policy of Slothtech</h1>

            <p>Slothtech operates the events.slothtech.io website, which provides the SERVICE.</p>

            <p>This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the Slothtech Events website.</p>

            <p>If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.</p>

            <p>
              The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at events.slothtech.io, unless otherwise defined in this Privacy Policy. Our Privacy Policy was created with the help of the
              <a
                href="https://www.privacypolicytemplate.net"
              >Privacy Policy Template</a> and the
              <a
                href="https://www.privacy-policy-template.com/"
              >Online Privacy Policy Template</a>.
            </p>
          </div>
          <div id="information-collection" name="information-collection">
            <h2>Information Collection and Use</h2>

            <p>For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.</p>
          </div>
          <div id="log-data" name="log-data">
            <h2>Log Data</h2>

            <p>We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.</p>
          </div>
          <div id="cookies" name="cookies">
            <h2>Cookies</h2>

            <p>Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.</p>

            <p>Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.</p>

            <p>
              For more general information on cookies, please read
              <a
                href="https://www.cookieconsent.com/what-are-cookies/"
              >"What Are Cookies"</a>.
            </p>
          </div>
          <div id="services-providers" name="services-providers">
            <h2>Service Providers</h2>

            <p>We may employ third-party companies and individuals due to the following reasons:</p>

            <ul>
              <li>To facilitate our Service;</li>
              <li>To provide the Service on our behalf;</li>
              <li>To perform Service-related services; or</li>
              <li>To assist us in analyzing how our Service is used.</li>
            </ul>

            <p>We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p>
          </div>
          <div id="security" name="security">
            <h2>Security</h2>
            <p>We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p>
          </div>
          <div id="links" name="links">
            <h2>Links to Other Sites</h2>

            <p>Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

            <p>Children's Privacy</p>

            <p>Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.</p>
          </div>
          <div id="changes" name="changes">
            <h2>Changes to This Privacy Policy</h2>

            <p>We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.</p>
          </div>
          <div id="contact" name="contact">
            <h2>Contact Us</h2>

            <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
a {
  color: inherit;
}
p {
  margin: 0;
  padding: 0;
}
.lg-terms {
  margin-right: 1rem;
  margin-top: -0.25rem;
}
.cnt-terms {
  width: 100vw;
  background-color: white;
}
.nv-terms {
  background: #fff;
  border-bottom: 1px solid rgba(151, 151, 151, 0.5);
  box-sizing: border-box;
  height: 80px;
  padding-left: 1rem;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  z-index: 2000;
  position: fixed;
  width: 100%;
}
.terms {
  padding-top: 80px;
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 3rem;
  @media (max-width: 599px) {
    grid-template-columns: 1fr;
    .terms-sidebar {
      display: none;
    }
    .terms-content {
      padding: 1rem;
    }
  }
}
.terms-sidebar {
  padding: 2rem;
}
.terms-sidebar {
  border-right: 1px solid rgba(151, 151, 151, 0.5);
}
.terms-content {
  display: grid;
  grid-template-columns: repeat(1fr);
  gap: 1rem;
}
.list-terms {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-top: 1rem;
  position: sticky;
  top: 80px;
  overflow: hidden;
  height: max-content;
}
.item-terms {
  letter-spacing: 0;
  line-height: 1.54;
  padding: 0;
  font-size: 0.85rem;
  width: max-content;
}
.item-terms a {
  display: block;
  padding: 13px 24px;
  &.active {
    color: #5ed6c8;
  }
}
.terms-content div {
  padding-top: 60px;
  h2 {
    color: #3c4043;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    margin: 0;
    padding: 64px 0 0 0;
  }
  p {
    letter-spacing: 0.2px;
    line-height: 24px;
    padding-top: 20px;
    margin: 10px 0;
  }
}
</style>